import { Callout } from "@softura/fluentuipackage";
interface IProps {
  children?: any;
  toggleIsCalloutVisible?: Function;
  targetId?: any;
  className?:string,
  calloutMaxHeight?:any
}
const CalloutContainer = ({
  children = null,
  toggleIsCalloutVisible,
  targetId,
  className,
  calloutMaxHeight
}: IProps) => {
  return (
    <Callout
      targetID={targetId}
      toggleIsCalloutVisible={toggleIsCalloutVisible}
      className={className}
      calloutMaxHeight={calloutMaxHeight}
     data-attribute="index_Default_Callout_2">
      {children}
    </Callout>
  );
};

export default CalloutContainer;
